export const enum UserSignInStatechartActionEnum {
  /**
   * Validate user input
   */
  validateInput = 'validateInput',

  /**
   * Show loader
   */
  showLoader = 'showLoader',

  /**
   * Execute captcha
   */
  executeCaptcha = 'executeCaptcha',

  /**
   * Set remember me flag
   */
  setRememberMe = 'setRememberMe',

  /**
   * Send register request to backend
   */
  signIn = 'signIn',

  /**
   * Reset captcha token
   */
  resetCaptchaToken = 'resetCaptchaToken',
}
